import { PartnerDetail as PartnerDetailComponent } from './PartnerDetail.component';
import { connector } from './PartnerDetail.connector';

export const PartnerDetail = connector(PartnerDetailComponent);
